import { tEngine } from "../../i18n/engine";
import { t } from "../../i18n";
import { fmt, type CaseId, type WallResult } from "@tasduvar/engine";
export function JointsSummary({ result, cases }: { result: WallResult; cases: CaseId[] }): JSX.Element | null {
  if (result.joints.length === 0) return null;
  return (
    <div>
      <h3 className="text-xs font-medium text-ink border-b border-rule pb-1 mb-1">{t("İç kesit kontrolleri")}</h3>
      <ul className="text-[11px] grid gap-1">
        {result.joints.map((j) => (
          <li key={j.level} className="flex gap-2 items-start">
            <span aria-hidden className={j.allOk ? "text-ok" : "text-bad"}>{j.allOk ? "✓" : "✗"}</span>
            <div><div className="font-medium">{tEngine(j.label)} · b = {fmt(j.width, 2)} m</div>
              {cases.map((c) => j.cases[c] ? <div key={c} className={j.cases[c]!.ok ? "text-ink/75" : "text-bad"}>{c === "static" ? t("Statik") : t("Deprem")}: {j.cases[c]!.verdict}</div> : null)}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
